/* ============================================================
   BOOKER — Cálculos de reajuste / correção monetária
   ============================================================ */
(function () {
  const { INDICES, indiceAcumulado, addMeses, HOJE, parseData } = window.DB;

  /* Data do PRÓXIMO reajuste contratual (próximo aniversário ainda no futuro).
     Avança a partir do último reajuste/início até passar de hoje — senão um
     contrato antigo sem reajuste mostraria o 1º aniversário, lá no passado. */
  function proximoReajuste(k) {
    // aniversários ancorados na DATA DE INÍCIO do contrato (não no último reajuste)
    let d = addMeses(parseData(k.dataInicio || k.ultimoReajuste), k.periodicidade);
    let guard = 0;
    while (d <= HOJE && guard++ < 600) d = addMeses(d, k.periodicidade);
    return d;
  }

  /* Valor que DEVERIA estar sendo cobrado hoje, aplicando o índice
     do contrato a cada aniversário vencido desde o último reajuste. */
  function correcaoDevida(k, ref = HOJE) {
    const inicio = parseData(k.dataInicio || k.ultimoReajuste);
    const ultReaj = parseData(k.ultimoReajuste);
    const per = k.periodicidade;
    let valor = k.valorAtual;
    let ciclos = 0;
    const aplicacoes = [];
    // Aniversários de reajuste ANCORADOS na data de início do contrato.
    // Conta só os que estão APÓS o último reajuste e até hoje — assim a
    // divergência não recorrige um valor que já foi atualizado (ex.: cronograma).
    let aniv = inicio, guard = 0;
    while (aniv <= ref && guard++ < 600) {
      if (aniv > ultReaj) {
        const de = addMeses(aniv, -per);
        const pct = indiceAcumulado(k.indice, de, aniv);
        const anterior = valor;
        valor = valor * (1 + pct / 100);
        aplicacoes.push({ de, ate: aniv, pct, anterior, novo: valor });
        ciclos++;
      }
      aniv = addMeses(aniv, per);
    }
    return {
      valorDevido: valor,
      valorCobrado: k.valorAtual,
      divergencia: valor - k.valorAtual,
      ciclosPendentes: ciclos,
      aplicacoes,
      proxima: proximoReajuste(k),
    };
  }

  /* Correção AUTOMÁTICA e consultiva: ancora no VALOR INICIAL e aplica o índice
     do contrato a CADA aniversário desde a DATA DE INÍCIO até hoje. Devolve o
     valor corrigido + a memória de cálculo. NÃO altera nada (só consulta). */
  function correcaoAutomatica(k, ref = HOJE) {
    const inicio = parseData(k.dataInicio);
    const per = k.periodicidade || 12;
    const base = (k.valorInicial != null ? k.valorInicial : k.valorAtual);
    let valor = base;
    const aplicacoes = [];
    let aniv = addMeses(inicio, per), guard = 0;   // 1º aniversário (após 1 período)
    while (aniv <= ref && guard++ < 600) {
      const de = addMeses(aniv, -per);
      const pct = indiceAcumulado(k.indice, de, aniv);
      valor = valor * (1 + pct / 100);
      aplicacoes.push({ de, ate: aniv, pct, novo: valor });
      aniv = addMeses(aniv, per);
    }
    return {
      valorInicial: base,
      valorDevido: valor,            // valor corrigido até hoje
      valorCobrado: k.valorAtual,    // valor que está no sistema
      divergencia: valor - k.valorAtual,
      ciclosPendentes: aplicacoes.length,
      aplicacoes,
      proxima: proximoReajuste(k),
    };
  }

  /* Simulação com percentual manual (legado — não usado na tela consultiva) */
  function simularManual(base, pct) {
    const novo = base * (1 + pct / 100);
    return { novo, delta: novo - base, pct };
  }

  /* Projeção de N reajustes futuros usando acum12 do índice */
  function projecao(k, anos = 3) {
    const idx = INDICES[k.indice];
    const taxa = idx.acum12 / 100;
    let valor = k.valorAtual;
    const pts = [{ ano: parseData(k.ultimoReajuste).getFullYear(), valor }];
    for (let i = 1; i <= anos; i++) {
      valor = valor * (1 + taxa);
      pts.push({ ano: parseData(k.ultimoReajuste).getFullYear() + i, valor });
    }
    return pts;
  }

  window.DB.calc = { proximoReajuste, correcaoDevida, correcaoAutomatica, simularManual, projecao };
})();
